import { render, staticRenderFns } from "./ReferralMarketingAgenciesList.vue?vue&type=template&id=3dd39b25&"
import script from "./ReferralMarketingAgenciesList.vue?vue&type=script&lang=js&"
export * from "./ReferralMarketingAgenciesList.vue?vue&type=script&lang=js&"
import style0 from "./ReferralMarketingAgenciesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCol,VRow,VSwitch})
